import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Href } from "../../../Utils/Constants";

export interface SimpleNavProps {
  basicTab: string;
  setBasicTab: (data: string) => void;
  filterValue: string;
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void; // Fix type
  clearFilter: () => void; // Fix type
}

export default function MaterialStyleNav({
  basicTab,
  setBasicTab,
  filterValue,
  onFilterChange,
  clearFilter,
}: SimpleNavProps) {
  return (
    <div className="d-flex">
      <Nav tabs className="border-tab border-0 mb-0 nav-danger">
        <NavItem>
          <NavLink
            href={Href}
            className={`nav-border txt-danger nav-danger ${basicTab === "1" ? "active" : ""}`}
            onClick={() => setBasicTab("1")}
          >
            {"Countries List"}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href={Href}
            className={`nav-border txt-danger nav-danger ${basicTab === "2" ? "active" : ""}`}
            onClick={() => setBasicTab("2")}
          >
            {"Active Countries List"}
          </NavLink>
        </NavItem>
      </Nav>

      {/* Search Input */}
      <div className="countries_flag d-flex gap-2 align-items-center text-capitalize justify-content-end position-relative">
        <p className="">Search:</p>
        <input
          type="text"
          onChange={onFilterChange}
          value={filterValue}
          className="form-control"
        />
        {filterValue && (
          <div onClick={clearFilter} className="close_icon position-absolute">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
}
